<template>
  <div class="pc_only">
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: #FF8400;" v-on:click="ichiran()">
        ← <slot>タイトル</slot>
        <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
    </span>
  <div class="p-1" style="margin-top:0;background-color:white">

    <!-- ユーザー登録後アンケート未回答の場合（実施する場合のみ） -->
     <!-- 各文言はuserdata.jsより -->
     <div v-if="enqete_ok == 0" style="text-align:center">
     {{GlobalData.$enqete_mikaitou}}<br>
      <span v-on:click="move_enqete" style="color:red;cursor: pointer;"><u>{{GlobalData.$enqete_link}}</u></span><br>
      <hr style="width:100%">
    </div>

    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item" v-on:click="ichiran" style="cursor:pointer">体験プログラム一覧</li>
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
    
        
    <div id="manual_area">

<span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験プログラムのマニュアル</span>
<span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

</div>

<br clear="all">
         <!-- ボタン（PCのみ） -->
         <div class="pc_only" style="text-align:center;padding:6px">
            
         <!-- 体験OKフラグが立ってないと申し込めない -->
            <template v-if="taiken_ok == 1">
                <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;margin-right:10px" v-on:click="moshikomi_set()" v-if="shakyo_moshikomi_flg == true && seisaku_moshikomi_flg == true && joken_moshikomi_flg == true">申込み</button>
            </template>
            <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-on:click="ichiran()">戻る</button>
        </div>
    <div class="p-2">
        <!-- 施設・体験の場合のみタブ切替 -->
        <!-- タブ切り替え タブ3つ -->
        <div id="tab" v-if="taiken.shubetsu==1">
            <ul class="tabMenu">
                <li @click="TabSelect('tab_detail')" id="tab_detail" v-bind:class="detail_color">詳細内容</li>
                <li @click="TabSelect('tab_list')" id="tab_list" v-bind:class="list_color" style="width:34%">日程一覧</li>
                <li @click="TabSelect('tab_calendar')" id="tab_calendar" v-bind:class="calendar_color">カレンダー</li>
            </ul>
        </div>

        <div class="tabContents" v-bind:class="contents_color">
            
            <!-- ユーザー登録後アンケート未回答の場合（実施する場合のみ） -->
            <div v-if="enqete_ok == 0" style="text-align:center">
                <!--
            体験プログラムのお申し込みにはアンケートにご回答いただく必要があります。<br>
            <span v-on:click="move_enqete" style="color:red;cursor: pointer;"><u>アンケートフォームへ移動する</u></span><br>
            <hr style="width:100%">-->
            </div>

            <div v-else-if="taiken_ok == 0">
                <p style="color:red"><b>体験プログラムの申込みには、<span v-on:click="jizen_list"><u style="cursor:pointer">事前研修への参加</u></span>が必要です。</b></p>
            </div>
            <div v-else-if="taiken.shubetsu == 2 || (taiken.shubetsu == 1 && TabActive != 'tab_detail')">

                
                <div v-if="shakyo_moshikomi_flg == false && taiken.shubetsu == 1">
                    <p style="color:red"><b>申込開始日まで今しばらくお待ちください。</b></p>
                    
                </div>
                <div v-else-if="joken_moshikomi_flg == false && taiken.shubetsu == 1">
                    <p style="color:red"><b>このプログラムの参加条件を満たしていません。</b></p>
                </div>
                <div v-else-if ="seisaku_moshikomi_flg == false">
                    <p style="color:red"><b>このプログラムは満員です。</b></p>
                </div>
                <div v-else>
                    <div v-if="mode=='nologin'" style="text-align:left;font-size:19px;">
                        <p style="color:red"><b>体験プログラムの申込みには、<span v-on:click="login"><u style="cursor:pointer">ログイン</u></span>が必要です。</b></p>
                    </div>
                    <div v-if="mode=='noinfo'" style="text-align:left;font-size:19px;">
                        <p style="color:red"><b>体験プログラムの申込みには、ユーザー情報（プロフィール）の登録が必要です。<br><u v-on:click="userinfo()" style="cursor: pointer;">マイページ</u>から登録してください。</b></p>
                    </div>
                </div>
            </div>
            <div v-if="taiken.shubetsu == 1 && TabActive != 'tab_detail'">

                <div style="width: 100%;text-align: left;padding-top: 10px;display: flex;align-items: center;">
                    <span style="font-size:20px;color:#030ba0"><b>{{ taiken.taiken_no  }}：{{ taiken.name  }}</b></span>
                </div>

                <span style="width: 100%;text-align: left;display: flex;align-items: center">
                    <b >活動日数：</b>
                    <!-- 日程の自・至が両方とも空欄なら非表示 -->
                    <span style="display: flex;;font-size:19px" v-if="(taiken.nissu_min != '' || taiken.nissu_min != null ) && (taiken.nissu_max != '' || taiken.nissu_max != null ) ">
                            <span v-if=" taiken.nissu_min == taiken.nissu_max ">
                            {{ taiken.nissu_min  }}日
                            </span>                            
                            <span v-else-if="taiken.nissu_min != taiken.nissu_max ">
                            <span v-if="taiken.nissu_max == '' || taiken.nissu_max == null ">
                                {{ taiken.nissu_min  }}日以上
                            </span>
                            <span v-else-if="taiken.nissu_min == '' || taiken.nissu_min == null ">
                                {{ taiken.nissu_max  }}日以下
                            </span>
                            <span v-else>
                                {{taiken.nissu_min}} ～ {{taiken.nissu_max}}日
                            </span>
                            </span>&nbsp;&nbsp;
                            <span v-if="taiken.nissu_joken == 1">連続</span>

                        </span>
                    </span>
                    
                    <span v-if="taiken.nissu_joken == 1 && taiken.nissu_jogai != true" style="color:red;text-align: left;display: flex;justify-content: flex-start;">
                        除外日及び除外曜日を飛ばした選択はできません。
                    </span>
                    <span style="width: 100%;text-align: left;display: flex;align-items: center;color:red" v-if="taiken.nissu_douitsu == false && douitsu_flg == 1">
                        <b>同一日申込：</b><span style="font-size:19px">不可</span>
                    </span>

                    
            </div>

            <div v-if="taiken.shubetsu == 1 && TabActive != 'tab_detail'" >
                <div style="text-align:left">
                    <template v-if="shosai_disp[6] == 1 && taiken.s_comment!=null">
                        <b>受入先からのコメント：</b>{{taiken.s_comment}}<br>
                    </template>
                    <template v-if="nittei_comment!=''">
                    <b>日程のコメント：</b>{{nittei_comment}}<br>
                    </template>
                <template v-if="taiken.bikou != '' && taiken.bikou != null">
                    <b>特記事項：</b><span style='color:red'>{{taiken.bikou}}</span>
                </template>
                </div>
                <div v-if="mode=='nologin' || mode=='noinfo'" style="float:left;color:red;margin-top:5px;font-size:17px">
                    <b>申込状況</b>
                </div>
                <div v-else-if=" TabActive == 'tab_list'" style="float:left;color:red;margin-top:5px;font-size:17px">
                   <b>"時間帯"をクリックしてください。</b>
               </div>
               <div v-else-if="TabActive == 'tab_calendar'" class="pc_only" style="float:left;color:red;margin-top:5px;font-size:17px">
                   <b>"時間帯"をクリックしてください。</b>
               </div>
            </div>
            <br clear="all" v-if="mode=='nologin' || mode=='noinfo'" >
            <br clear="all" v-else-if="TabActive == 'tab_list'" >
            <br clear="all" v-else-if="TabActive == 'tab_calendar'"  class="pc_only" >
            
            <div v-if="TabActive === 'tab_detail'">
                
                <div v-if="shakyo_moshikomi_flg == false && taiken.shubetsu == 1">
                    <p style="color:red"><b>申込開始日まで今しばらくお待ちください。</b></p>
                    
                </div>
                <div v-else-if="joken_moshikomi_flg == false && taiken.shubetsu == 1">
                    <p style="color:red"><b>このプログラムの参加条件を満たしていません。</b></p>
                </div>
                <div v-else-if ="seisaku_moshikomi_flg == false && taiken.shubetsu == 1">
                    <p style="color:red"><b>このプログラムは満員です。</b></p>
                </div>
                <span style="text-align: left;float: left;padding:5px">
                    {{ taiken.bunrui1 }}<br>
                    <span v-if="shosai_disp[1] == 1">{{ taiken.bunrui2 }}</span>
                </span><br>
                <!-- 施設・地域活動 -->
                <table class="vy-form-table" v-if="taiken.shubetsu == 1"  style="margin-bottom:0px">
                    <!-- No. プログラム名称 -->
                    <tr>
                        <td colspan="2"><div class="vy-dotted pc_only"></div></td>
                    </tr>
                    <tr>
                        <th>
                            <label for=""  class="pc_only">No.：名称（施設名等） </label>
                        </th>
                        <td style="text-align: left;font-size:22px;color:#030ba0">
                            <b>{{ taiken.taiken_no }}：{{ taiken.name }}</b>
                        </td>
                    </tr>

                    <!-- 活動内容 -->
                    <template v-if="shosai_disp[3] == 1">
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;">
                                {{ taiken.naiyou }}
                            </td>
                        </tr>
                    </template>
                     <!-- 開催地名 -->
                     <template v-if="shosai_disp[18] == 1 && taiken.k_name != null && taiken.k_name != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    開催地名
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        開催地名
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;" >
                            {{ taiken.k_name }}
                            </td>
                        </tr>
                    </template>
                        <!-- 施設住所 -->
                    <template v-if="shosai_disp[4] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    施設住所
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、開催場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        施設住所
                                    </label>
                                    <span class="balloon_parent ">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、開催場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span>
                                
                            </th>
                            <td style="text-align: left;color:red;cursor:pointer" v-on:click="jusho(taiken.k_jusyo)">
                                <u>{{ taiken.k_jusyo }}</u>
                            </td>
                        </tr>
                    </template>
                     <!-- 連絡先 -->
                     <template v-if="shosai_disp[19] == 1 && taiken.k_tel != null && taiken.k_tel != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    連絡先
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        連絡先
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;color:red;cursor:pointer" >
                                <u>{{ taiken.k_tel }}</u>
                            </td>
                        </tr>
                    </template>
                    
                        <!-- 活動日数 -->
                    <template v-if="shosai_disp[5] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">活動日数</label>
                            </th>
                            <td style="text-align: left">
                                <span v-if=" taiken.nissu_min == taiken.nissu_max ">
                                {{ taiken.nissu_min  }}日
                                </span>                            
                                <span v-else-if="taiken.nissu_min != taiken.nissu_max ">
                                <span v-if="taiken.nissu_max == '' || taiken.nissu_max == null ">
                                    {{ taiken.nissu_min  }}日以上
                                </span>
                                <span v-else-if="taiken.nissu_min == '' || taiken.nissu_min == null ">
                                    {{ taiken.nissu_max  }}日以下
                                </span>
                                <span v-else>
                                    {{taiken.nissu_min}} ～ {{taiken.nissu_max}}日
                                </span>
                                </span>&nbsp;&nbsp;
                                <span v-if="taiken.nissu_joken == 1">連続</span>
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 日程 -->
                    <!-- 「table」内でv-forを使うときは「template」で囲む -->
                    <template v-for="(result,i) in taiken.nittei" v-bind:key="i" >
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- 日程 -->
                        <tr>
                            <th>
                                <label for="">
                                    <template v-if="taiken.nittei.length != 1">日程{{ i + 1 }}</template>
                                    <template v-else>日程</template>
                                </label>
                            </th>
                            <td style="text-align: left">
                            

                                    <b>開催日：</b>{{DateSetting(result.kaisai_start)}} <span v-if="result.kaisai_end && result.kaisai_end != result.kaisai_start">～{{DateSetting(result.kaisai_end)}}</span><br>
                                    
                                    <b>開催時間：</b><span v-if="result.jikantai_start">{{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}</span><br> 
                                    <span v-if="(result.kaisai_youbi != null)"><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} <br></span>
                                    <span v-if="(result.jogai != null)"><b>除外曜日：</b>{{youbi_irekae(result.jogai)}} <br></span>
                                    <span v-if="(result.jogai_date != null)"><b>除外日：</b>{{result.jogai_date}} <br></span>
                                               
                                    <b>定員：</b>   
                                    <template v-if="result.teiin >= 999">
                                        無し
                                    </template>
                                    <template v-else>
                                        <span v-if="result.teiin">{{result.teiin}} 名</span>
                                    </template>
                                    <br>
                                    <span v-if="(result.comment != null)"><b>コメント：</b>{{ result.comment }}</span>
                                    
                            </td>
                        </tr>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 申込〆切 -->
                    <tr>
                        <th>
                            <label for="">申込〆切</label>
                        </th>
                        <td style="text-align: left;">
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝開催日から〇日前まで申込可能
                            -->
                            <span v-if="end_shubetsu == 1">{{DateTimeSetting(end_datetime)}}</span>
                            <span v-else-if="taiken.shimekiri_date">{{EuDateTimeSetting(taiken.shimekiri_date)}}</span>
                            <span v-else>開催日の{{taiken.shimekiri_nissu}}日前まで申込可能</span>
                        </td>
                    </tr>
                    
                        <!-- 参加条件（対象者） -->
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">参加条件（対象者）</label>
                            </th>
                            <td style="text-align: left;">
                                    <span v-if="(taiken.joken_syogaku != '〇' && taiken.joken_syogaku != 'ー' ) || taiken.joken_syogaku == '〇'">
                                        小：{{ taiken.joken_syogaku }}<span v-if="taiken.joken_syogaku != '〇' && taiken.joken_syogaku != 'ー' ">年生</span>
                                    <!-- 後続が一つでも存在していたら読点で区切る -->
                                            <span v-if="((taiken.joken_chugaku != '〇' && taiken.joken_chugaku != 'ー') || taiken.joken_chugaku == '〇') ||
                                                        ((taiken.joken_koukou != '〇' && taiken.joken_koukou != 'ー') || taiken.joken_koukou == '〇')||
                                                        ((taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー') || taiken.joken_daigaku == '〇')||
                                                        ((taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇')">
                                                、
                                            </span>
                                            </span>
                                            <span v-if="(taiken.joken_chugaku != '〇' && taiken.joken_chugaku != 'ー') || taiken.joken_chugaku == '〇'">
                                            中：{{ taiken.joken_chugaku }}<span v-if="taiken.joken_chugaku != '〇' && taiken.joken_chugaku != 'ー' ">年生</span>
                                            <!-- 後続が一つでも存在していたら読点で区切る -->
                                            <span v-if="((taiken.joken_koukou != '〇' && taiken.joken_koukou != 'ー') || taiken.joken_koukou == '〇')||
                                                        ((taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー') || taiken.joken_daigaku == '〇')||
                                                        ((taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇')">
                                                、
                                            </span>
                                            </span>
                                            <span v-if="(taiken.joken_koukou != '〇' && taiken.joken_koukou != 'ー') || taiken.joken_koukou == '〇'">
                                                高：{{ taiken.joken_koukou }}<span v-if="taiken.joken_koukou != '〇' && taiken.joken_koukou != 'ー' ">年生</span>
                                            
                                            <!-- 後続が一つでも存在していたら読点で区切る -->
                                            <span v-if="((taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー') || taiken.joken_daigaku == '〇')||
                                                        ((taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇')">
                                                、
                                            </span>
                                            </span>
                                            <span v-if="(taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー') || taiken.joken_daigaku == '〇'">
                                                専・大・大院：{{ taiken.joken_daigaku }}<span v-if="taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー' ">年生</span>
                                            <!-- 後続が一つでも存在していたら読点で区切る -->
                                            <span v-if="((taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇')">
                                                、
                                            </span>
                                            </span>
                                            <span v-if="(taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇'">他：{{ taiken.joken_sonota }}
                                            </span>
                            </td>
                        </tr>
                        
                    
                        <!-- 参加費 -->
                    <template v-if="shosai_disp[9] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>

                        <tr>
                            <th>
                                <label for="">参加費</label>
                            </th>
                            <td style="text-align: left;">
                                <span v-if="taiken.sankahi == null || taiken.sankahi == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{taiken.sankahi}}
                                </span>
                            </td>
                        </tr>
                    </template>
                    
                        <!-- 検温等 -->
                    <template v-if="shosai_disp[10] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">検温等</label>
                            </th>
                            <td style="text-align: left;">
                                <span v-if="taiken.kensa == null || taiken.kensa == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{taiken.kensa}}
                                </span>
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 検便 -->
                <template v-if="shosai_disp[17] == 1">
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <tr>
                        <th>
                            <label for="">検便</label>
                        </th>
                        <td style="text-align: left;">
                            <span v-if="taiken.kenben == null || taiken.kenben == ''">
                                不要
                            </span>
                            <span v-else>
                            {{taiken.kenben}}
                            </span>
                        </td>
                    </tr>
                </template>
                    <!-- マスク着用 -->
                    <template v-if="shosai_disp[11] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">マスク着用</label>
                            </th>
                            <td style="text-align: left;">
                                <span v-if="taiken.mask == null || taiken.mask == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{taiken.mask}}
                                </span>
                            </td>
                        </tr>
                    </template>
                    
                        <!-- 昼食 -->
                    <template v-if="shosai_disp[12] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">昼食</label>
                            </th>
                            <td style="text-align: left;">
                                <span v-if="taiken.chusyoku == null || taiken.chusyoku == '' || taiken.chusyoku == '不要'">
                                    無し
                                </span>
                                <span v-else-if="taiken.chusyoku == '要'">
                                    有り
                                </span>
                                <span v-else>
                                {{taiken.chusyoku}}
                                </span>
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 持ち物 -->
                    <template v-if="shosai_disp[13] == 1">
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                        <tr>
                            <th>
                                <label for="">持ち物</label>
                            </th>
                            <td style="text-align: left;">
                                {{taiken.mochimono}}
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 受入先からのコメント -->
                    <template v-if="shosai_disp[6] == 1 && taiken.s_comment!=null">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr >
                            <th>
                                <label for="">受入先からのコメント</label>
                            </th>
                            <td style="text-align: left;">
                                {{taiken.s_comment}}
                            </td>
                        </tr>
                    </template>
                    <!-- 添付資料 -->
                    <template v-if="shosai_disp[7] == 1 && (taiken.shiryo_url!=null && taiken.shiryo_url!='')">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr >
                            <th rowspan=2>
                                <label for="">添付資料</label>
                            </th>
                            <td style="text-align: left;">
                                {{taiken.shiryo_setsumei}}
                            </td>
                        </tr>
                        <!-- 添付資料 -->
                        <tr >
                            <td style="text-align: left;">
                                <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(taiken.shiryo_url)">資料を閲覧する</u>
                                <a v-bind:href="taiken.shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                            </td>
                        </tr>
                    </template>
                    
                    <template v-if="shosai_disp[8] == 1 && taiken.bikou!=null ">
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- その他（特記事項） -->
                        <tr>
                            <th>
                                <label for="">その他（特記事項）</label>
                            </th>
                            <td style="text-align: left;color:red">
                                {{taiken.bikou}}
                            </td>
                        </tr>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                </table>

                <!-- 自宅・寄付活動 -->
                <table class="vy-form-table" v-if="taiken.shubetsu == 2" style="margin-bottom:0px">

                    <!-- No. プログラム名称 -->
                    <tr>
                        <th>
                            <label for=""  class="pc_only">No.：名称（施設名等） </label>
                        </th>
                        <td style="text-align: left;font-size:22px;color:#030ba0">
                            <b>{{ taiken.taiken_no }}：{{ taiken.name }}</b>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2"><div class="vy-dotted pc_only"></div></td>
                    </tr>

                    <!-- 活動内容 -->
                    <template v-if="shosai_disp[3] == 1 ">
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;">
                                {{ taiken.naiyou }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                    
                        <!-- 施設住所 -->
                    <template v-if="shosai_disp[4] == 1 ">
                        <tr>
                            <th>

                                <label class="sp_only">
                                    施設住所
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、提出場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label for="">施設住所</label>
                                    <span class="balloon_parent">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、提出場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span>    
                            </th>
                            <td style="text-align: left;color:red;cursor:pointer" v-on:click="jusho(taiken.k_jusyo)">
                                <u>{{ taiken.k_jusyo }}</u>
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                     <!-- 連絡先 -->
                     <template v-if="shosai_disp[19] == 1 && taiken.k_tel != null && taiken.k_tel != ''">
                        <tr>
                            <th>
                                <label class="sp_only">
                                    連絡先
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        連絡先
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;color:red;cursor:pointer" >
                                <u>{{ taiken.k_tel }}</u>
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                    <!-- 開催期間 -->
                    <tr>
                        <th>
                            <label for="">開催期間</label>
                        </th>
                        <td style="text-align: left">
                            
                            {{DateSetting(taiken.kaisai_start)}}
                            <span v-if="taiken.kaisai_end && taiken.kaisai_end != taiken.kaisai_start"> ～ {{DateSetting(taiken.kaisai_end)}}</span>
                        </td>
                    </tr>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>

                    <!-- 申込〆切 -->
                    <tr>
                        <th>
                            <label for="">申込〆切</label>
                        </th>
                        <td style="text-align: left;">
                            
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝申込日の〇日前まで申込可能
                            -->
                            <span v-if="end_shubetsu == 1">{{DateTimeSetting(end_datetime)}}</span>
                            <span v-else-if="taiken.shimekiri_date">{{EuDateTimeSetting(taiken.shimekiri_date)}}</span>
                            <span v-else>開催日の{{taiken.shimekiri_nissu}}日前まで申込可能</span>
                        </td>
                    </tr>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 制作・寄付活動条件 -->
                    <template v-if="shosai_disp[14] == 1 && taiken.seisaku_joken!=null ">
                        <tr>
                            <th>
                                <label for="seisaku_joken">制作・寄付活動条件</label>
                            </th>
                            <td style="text-align: left;">
                                {{taiken.seisaku_joken}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                     
                    </template>
                    
                    <!-- 届け先 -->
                    <template v-if="shosai_disp[15] == 1 ">
                        <tr>
                            <th>
                                <label for="todokesaki">届け先</label>
                            </th>
                            <td style="text-align: left;">
                                {{taiken.todokesaki}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>

                    </template>

                    <!-- 参加条件（対象者） -->
                    <tr>
                        <th>
                            <label for="">参加条件（対象者）</label>
                        </th>
                        <td style="text-align: left;">
                            <span v-if="(taiken.joken_syogaku != '〇' && taiken.joken_syogaku != 'ー' ) || taiken.joken_syogaku == '〇'">
                                        小：{{ taiken.joken_syogaku }}<span v-if="taiken.joken_syogaku != '〇' && taiken.joken_syogaku != 'ー' ">年生</span>
                                    <!-- 後続が一つでも存在していたら読点で区切る -->
                                            <span v-if="((taiken.joken_chugaku != '〇' && taiken.joken_chugaku != 'ー') || taiken.joken_chugaku == '〇') ||
                                                        ((taiken.joken_koukou != '〇' && taiken.joken_koukou != 'ー') || taiken.joken_koukou == '〇')||
                                                        ((taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー') || taiken.joken_daigaku == '〇')||
                                                        ((taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇')">
                                                、
                                            </span>
                                            </span>
                                            <span v-if="(taiken.joken_chugaku != '〇' && taiken.joken_chugaku != 'ー') || taiken.joken_chugaku == '〇'">
                                            中：{{ taiken.joken_chugaku }}<span v-if="taiken.joken_chugaku != '〇' && taiken.joken_chugaku != 'ー' ">年生</span>
                                            <!-- 後続が一つでも存在していたら読点で区切る -->
                                            <span v-if="((taiken.joken_koukou != '〇' && taiken.joken_koukou != 'ー') || taiken.joken_koukou == '〇')||
                                                        ((taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー') || taiken.joken_daigaku == '〇')||
                                                        ((taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇')">
                                                、
                                            </span>
                                            </span>
                                            <span v-if="(taiken.joken_koukou != '〇' && taiken.joken_koukou != 'ー') || taiken.joken_koukou == '〇'">
                                                高：{{ taiken.joken_koukou }}<span v-if="taiken.joken_koukou != '〇' && taiken.joken_koukou != 'ー' ">年生</span>
                                            
                                            <!-- 後続が一つでも存在していたら読点で区切る -->
                                            <span v-if="((taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー') || taiken.joken_daigaku == '〇')||
                                                        ((taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇')">
                                                、
                                            </span>
                                            </span>
                                            <span v-if="(taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー') || taiken.joken_daigaku == '〇'">
                                                専・大・大院：{{ taiken.joken_daigaku }}<span v-if="taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー' ">年生</span>
                                            <!-- 後続が一つでも存在していたら読点で区切る -->
                                            <span v-if="((taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇')">
                                                、
                                            </span>
                                            </span>
                                            <span v-if="(taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇'">他：{{ taiken.joken_sonota }}
                                            </span>
                        </td>
                    </tr>

                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    
                        <!-- 受入先からのコメント -->
                    <template v-if="shosai_disp[6] == 1 && taiken.s_comment!=null">
                        <tr>
                            <th>
                                <label for="">受入先からのコメント</label>
                            </th>
                            <td style="text-align: left;">
                                {{taiken.s_comment}}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                    
                    <!-- 添付資料 -->
                    <template v-if="shosai_disp[7] == 1 && (taiken.shiryo_url!=null && taiken.shosai_disp!='')">
                        <tr v-if="taiken.shiryo_url!=null && taiken.shiryo_url!=''">
                            <th rowspan=2>
                                <label for="">添付資料</label>
                            </th>
                            <td style="text-align: left;">
                                {{taiken.shiryo_setsumei}}
                            </td>
                        </tr>
                        <!-- 添付資料 -->
                        <tr >
                            <td style="text-align: left;">
                                
                                <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(taiken.shiryo_url)">資料を閲覧する</u>
                                <a v-bind:href="taiken.shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>

                    <!-- その他（特記事項） -->
                    <template v-if="shosai_disp[8] == 1 && taiken.bikou!=null">
                        <tr>
                            <th>
                                <label for="">その他（特記事項）</label>
                            </th>
                            <td style="text-align: left;color:red">
                                {{taiken.bikou}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                </table>
                <!--事前研修-->
                <div style="text-align:left;padding:5px" v-if="jizen.length != 0 && taiken_jizen_no.length != 0">
                    <label><b>事前研修</b></label>
                    <!-- PC -->
                    <table style="width: 100%;" class="pc_only">
                    <tr><td>研修名</td><td>研修日時</td><td>受付〆切日</td><td>体験開始日</td><td>場所・住所</td><td>定員</td><td>特記事項</td></tr>
                        
                        <tr v-for="(result,i) in jizen" v-bind:key="i" >
                    
                            <td width="14%">{{ result.jizen_name }} </td>
                            <td width="10%">{{ DateSetting(result.kensyu_date) }} 
                                <span v-if="result.syurui != 3"><br>
                                {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                </span>
                                <span v-else>まで</span>
                            </td>
                            <td width="13%">{{ DateSetting(result.shimekiri_date) }} </td>
                            <td width="13%">{{ DateSetting(result.taikenkaishi_date) }} </td>
                            <td width="25%">{{ result.basyo }}
                                <br>
                                <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                                <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                            </td>
                            <td width="10%">
                                <span v-if="result.syurui == 3">ー</span>
                                <span v-else-if="(result.teiin == '' || result.teiin == null)">ー</span>
                                <span v-else-if="result.teiin >= 999">無し</span>
                                <span v-else>
                                {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                                </span>
                            </td>
                            <td width="15%">
                                
                                <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                                <span v-else style="color:red">
                                {{ result.bikou1}} 
                                </span>
                            </td>
                    </tr>

                    </table>
                    <table style="width: 100%;" class="sp_only">
                        <template v-for="(result,i) in jizen" v-bind:key="i">
                                <tr>
                                    <td width="35%">研修名</td>
                                    <td width="65%">{{ result.jizen_name }} </td>
                                </tr>
                                <tr >
                                <td>
                                    <template v-if="result.syurui == 3">視聴期間</template>
                                    <template v-else>研修日時</template>
                                </td>
                                <td>
                                    {{ DateSetting(result.kensyu_date) }} 
                                    <span v-if="result.syurui != 3">
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                    </span>
                                    <span v-else>まで</span>
                                </td>

                                </tr>
                                <tr >
                                <td>受付〆切日</td>
                                <td>
                                    
                                    <span v-if="result.shimekiri_date == '' || result.shimekiri_date == null|| result.shimekiri_date == 'None'">ー</span>
                                    <span v-else> {{ DateSetting(result.shimekiri_date)  }}</span>
                                </td>

                                </tr>
                                <template  v-if="result.syurui != 3">
                                <tr>
                                <td>体験開始日</td>
                                <td>
                                    <template v-if="result.syurui == 3">ー</template>
                                    <template v-else>{{ DateSetting(result.taikenkaishi_date) }}</template>
                                </td>
                                
                                </tr>
                                    <tr>
                                    <td>場所</td>
                                    <td>
                                        
                                        <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                                        <span v-else> {{ result.basyo }}</span>
                                    </td>
                                    
                                    </tr>
                                </template>
                                <template v-if="result.syurui == '1'">
                                    <!-- 対面時のみ表示 -->
                                    <tr>
                                    <td>住所</td>
                                    <td>
                                        <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                                        <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                                    </td>
                                    </tr>
                                </template>
                                
                                <template  v-if="result.syurui != 3">
                                    <tr>
                                    <td>定員</td>
                                    <td>
                                        <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                                        <span v-else-if="result.teiin >= 999">無し</span>
                                        <span v-else>
                                        {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                                        </span>
                                    </td>
                                    </tr>
                                </template>
                                <tr>
                                <td>特記事項</td>
                                <td>
                                    <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                                    <span v-else style="color:red;">{{ result.bikou1 }}</span>
                                </td>
                                </tr>
                            <tr><td style="border:0"></td></tr>
                        </template>
                    
                    </table>
                    <div class="vy-dotted" style="margin-top:10px"></div>
                </div>
                <!--事後集会-->
                <div style="text-align:left;padding:5px" v-if="jigo.length != 0 && taiken_jigo_no.length != 0">
                        <label><b>事後集会</b></label>
                        <!-- PC -->
                        <table style="width: 100%;" class="pc_only">
                            <tr><td>集会名</td><td>集会日時</td><td>場所・住所</td><td>定員</td><td>特記事項</td></tr>
                                
                            <tr v-for="(result,i) in jigo" v-bind:key="i" >
                            
                                    <td width="14%">{{ result.jigo_name }} </td>
                                    <td width="10%">{{ DateSetting(result.kaisai_date) }}<br>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                    </td>
                                    <td width="40%">{{ result.basyo }}
                                        <br>
                                        <span v-if="result.jusyo == '' || result.jusyo == null"></span>
                                        <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                                    </td>
                                    <td width="10%">
                                        
                                        <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                                        <span v-else-if="result.teiin >= 999">無し</span>
                                        <span v-else>
                                        {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                                        </span>
                                    </td>
                                    <td width="26%">
                                        
                                        <span v-if="result.bikou1 == '' || result.bikou1 == null">ー</span>
                                        <span v-else style="color:red">
                                        {{ result.bikou1 }} 
                                        </span>
                                    </td>
                            </tr>

                         </table>
                         <table style="width: 100%;" class="sp_only">
                            <template v-for="(result,i) in jigo" v-bind:key="i">
                                <tr>
                                    <td width="35%">集会名</td>
                                    <td width="65%">{{ result.jigo_name }} </td>
                                </tr>
                                <tr >
                                    <td>集会日時</td>
                                    <td>
                                    {{ DateSetting(result.kaisai_date) }} 
                                    <span v-if="result.syurui != 3">
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                    </span>
                                    <span v-else>まで</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>場所</td>
                                    <td>
                                        <span v-if="result.basyo == '' || result.basyo == null|| result.basyo == 'None'">ー</span>
                                        <span v-else> {{ result.basyo }}</span>
                                    </td>
                                </tr>
                                <template v-if="result.syurui == '1'">
                                    <!-- 対面時のみ表示 -->
                                    <tr>
                                        <td>住所</td>
                                        <td>
                                        <span v-if="result.jusyo == '' || result.jusyo == null|| result.jusyo == 'None'">ー</span>
                                        <u v-else style="color:red;cursor:pointer" v-on:click="jusho(result.jusyo)">{{ result.jusyo }}</u>
                                        </td>
                                    </tr>
                                </template>
                                <tr>
                                    <td>定員</td>
                                    <td>
                                        <span v-if="result.teiin == '' || result.teiin == null">ー</span>
                                        <span v-else-if="result.teiin >= 999">無し</span>
                                        <span v-else>
                                        {{ result.sanka_ninzu }} 人 / {{ result.teiin }} 人
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>特記事項</td>
                                    <td>
                                    <span v-if="result.bikou1 == '' || result.bikou1 == null|| result.bikou1 == 'None'">ー</span>
                                    <span v-else style="color:red;">{{ result.bikou1 }}</span>
                                    </td>
                                </tr>
                                <tr><td style="border:0"></td></tr>
                            </template>
                        </table>
                    </div>
            </div>
            
        
            <!-- リスト表示タブの中身 -->
            <div v-else-if="TabActive === 'tab_list'" style="margin:10px auto;max-width: 1300px;border-bottom: 1px solid #000;">
                
                  <div id="title_area">
                    <div class="list_column_header list_column_left">開催日</div>
                    <div class="list_column_header list_column_center">時間帯</div>
                    <div class="list_column_header list_column_standard">

                        <span class="sp_only">
                            残り人数
                            <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('研修や他プログラムの参加日は選択できません。')" />
                        </span>
                        <span class="pc_only">
                            残り人数
                            <span class="balloon_parent ">
                                <img class="q_icon" src="../../images/mark/qmark.png"  />
                                <span class="balloon-top-right">
                                    研修や他プログラムの参加日は選択できません。
                                </span>
                            </span>
                        </span>


                    </div>

                    <!--
                    
                                <label class="sp_only">
                                    施設住所（開催場所）
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、開催場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        施設住所（開催場所）
                                    </label>
                                    <span class="balloon_parent ">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、開催場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span>
                    -->
                    
                  </div>
                  <div v-for="(result,i) in moshikomi_list" v-bind:key="i" class="vy-search-result-row">
                    <div id="list_column_area">
                      <!--一番最初の日付、または前の日と別日の場合-->
                      <div class="list_column_left" style="border-top:1px solid #000 ;" v-if=" i==0 || moshikomi_list[i-1].hyoji_date != result.hyoji_date  ">{{ result.hyoji_date }}({{ result.youbi }})</div>                      
                      
                      <!--前の日と同じ日の場合-->
                      <div class="list_column_left" v-else-if=" moshikomi_list[i-1].hyoji_date == result.hyoji_date"></div>
                      
                      <!--時間帯（v-ifで背景色を変えているが中身は一緒なので変更するときは両方直すこと）-->

                      <!-- 未ログイン・未ユーザー登録の場合は時間帯の表示のみ -->
                      <div v-if="mode=='nologin' || mode=='noinfo'" class="list_column_center" >
                          {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                      </div>

                      <!--選択済み時間帯の時-->
                      <div v-else-if="select_date.findIndex(({bango}) => bango == i) != -1" style="background-color: #AFA;" class="list_column_center" v-bind:id="['set_id' + i]" v-bind:class="['set_id' + i]">
                      
                        <!-- 定員がオーバーしていない場合はクリック可 -->
                        <span v-if="result.teiin > result.ninzu && result.moshikomi_flg == 0">
                        
                          <a href="#" v-on:click.prevent.stop="Set_id(result.check_date,result.jikantai_start,result.jikantai_end,i,1,result.date_bango)" class="vy-search-result-row-a">
                            
                            <u>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</u>
                          </a>
                        </span>

                        <!-- それ以外はクリック不可 -->
                        <span v-else>
                          {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                        </span>
                      
                      </div>

                      <!--未選択時間帯の時-->
                      <div v-else class="list_column_center" v-bind:id="['set_id' + i]" v-bind:class="['set_id' + i]">

                        <!-- 定員がオーバーしていない場合はクリック可 -->
                        <span v-if="result.teiin > result.ninzu && result.moshikomi_flg == 0">
                          
                          <a href="#" v-on:click.prevent.stop="Set_id(result.check_date,result.jikantai_start,result.jikantai_end,i,1,result.date_bango)" class="vy-search-result-row-a">
                            <u>{{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}</u>
                          </a>
                        </span>
                        <!-- それ以外はクリック不可 -->
                        <span v-else>
                          {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                        </span>
                      </div>
                      
                      <!--申込人数-->
                      <!-- 申し込むユーザーが既に他のプログラムでこの日時を申し込んでいた場合 -->
                      <div v-if="result.moshikomi_flg != 0" class="list_column_standard" style="background-color: pink;">
                        申込済
                        <span v-if="result.moshikomi_flg == 1" >
                          (体)
                        </span>
                        <span v-else>
                          (研)
                        </span>
                        
                      </div>
                      
                    <div v-else-if="(result.teiin - result.ninzu) <= 0" class="list_column_standard" style="background-color: pink;">
                        満員                    
                    </div>

                      <div v-else class="list_column_standard">
                        <template v-if="result.teiin >= 999">定員無し</template>
                        <template v-else>あと {{ result.teiin - result.ninzu }}人</template>
                        <!--  <span v-if="result.teiin != null"> / {{ result.teiin }}人</span>-->
                        
                      </div>
                    </div>
                  </div>
  
                </div>

                <!-- カレンダー表示タブの中身 -->
                <div v-else-if="TabActive === 'tab_calendar'" style="margin: 0 auto 10px; max-width: 1300px; ">
                  <div id="calendar_button_area">
                    <div v-on:click="Change_month(-1)" class="month_change">＜＜前月</div>
                    <div><h2 style="margin:0">{{ calendar_month }} 月</h2></div>
                    <div v-on:click="Change_month(1)" class="month_change">翌月＞＞</div>
                  </div>
                  <div id="title_area" style="border-bottom: 1px solid #000;">
                    <div class="list_column_header calendar_column_left" style="color: red;">日</div>
                    <div class="list_column_header calendar_column">月</div>
                    <div class="list_column_header calendar_column">火</div>
                    <div class="list_column_header calendar_column">水</div>
                    <div class="list_column_header calendar_column">木</div>
                    <div class="list_column_header calendar_column">金</div>
                    <div class="list_column_header calendar_column_right" style="color:blue">土</div>
                  </div>
                  <div id="calendar_area" v-html="Calendar" v-on:click="htmlColumnClick" class="pc_only"></div>
                  <div id="calendar_area" v-html="CalendarSp" v-on:click="htmlColumnClickSp" class="sp_only"></div>

                </div>
            </div>
        </div>
        <!-- ボタン（PCのみ） -->
        <div class="pc_only" style="text-align:center;padding:6px;width:100%">
            <!-- 体験OKフラグが立ってないと表示できない-->
            <template v-if="taiken_ok == 1">
             <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;margin-right: 10px;"  v-on:click="moshikomi_set()" v-if="shakyo_moshikomi_flg == true && seisaku_moshikomi_flg == true && joken_moshikomi_flg == true">申込み</button>
            </template>
          <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;"  v-on:click="ichiran()">戻る</button>
        </div>
      </div>
          
    
        <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
    <div class="vy-responsive-menu-container floating_over" style="
        margin-bottom: 50px;
        padding: 10px 0;
        background: rgba(0, 0, 0, .5);
        border: 0px;
        justify-content: space-evenly;">
        <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;margin-right:10px;background-color: white;color:#4175d0;border:1px solid #000"  v-on:click="ichiran()">一覧に戻る</button>
            
        <!-- 体験OKフラグが立ってないと表示できない-->
        <template v-if="taiken_ok == 1">
            <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0" v-on:click="moshikomi_set()" v-if="shakyo_moshikomi_flg == true && seisaku_moshikomi_flg == true && joken_moshikomi_flg == true">申込み</button>
        </template>
    </div>

      <!-- スマホ用・カレンダー日時を表示するモーダルウィンドウ-->
      <component v-if="smart_calendar_area"
               v-bind:is="contentCalendar"
               v-bind:param="paramCalendar"
               v-on:call="call"></component>

      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>
</template>

<script setup>
/* eslint-disable */

/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

/* スマホ用・カレンダーで選択した日付の時間帯を表示するモーダルウィンドウ */
import UserCalendarSmart from './UserCalendarSmart.vue'  

const contentCalendar = ref('')// 表示する子コンポーネントの情報（カレンダー日時エリア）
contentCalendar.value = null // 表示する子コンポーネント
let paramCalendar = {}//子コンポーネントに送る値の連想配列
let smart_calendar_area = ref(false)//表示・非表示フラグ


import { useRouter,useRoute } from 'vue-router'
import { GlobalData, DateSetting,TimeSetting,DateTimeSetting,youbi_irekae  } from '../js/userdata.js'
import AWS from 'aws-sdk';
import axios from 'axios'
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()
const prop = defineProps(['param'])
const taiken = prop.param.shosai
const jisseki = prop.param.jisseki // 体験プログラムに申し込まれている実績
const myjisseki = prop.param.myjisseki  // ユーザーが申し込んだ実績
const cityname = prop.param.cityname


// 日程からコメントを抽出
let nittei_comment = ""
for(let n = 0;n<taiken.nittei.length;n++){
    let nittei_kobetsu = taiken.nittei[n]
    if(nittei_comment != "") nittei_comment += "、"
    if(nittei_kobetsu.comment != "" && nittei_kobetsu.comment != null){
        nittei_comment += nittei_kobetsu.comment
    }
}

let holidays_list = []


// ユーザーが本来所属する社協の名前
let shozoku_name = ref(prop.param.shozoku_name)

// アンケート回答済みかどうか（0：未回答、1：回答済み、2：回答の必要なし、3：未確認）
const enqete_ok = ref(GlobalData.enqete_flg)


// ？マークをタップしたときのウィンドウ（スマホのみ）
let q_open = function(text){
    message.value = text
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "q_open";
    contentMessage.value = MessageModal

}
/*
// ファイル名を指定してユーザー登録後アンケートの回答CSVを取得し、ユーザーが回答しているかをチェックする
let answer_error = 0
let Form_answer_check = function() { 

  if(GlobalData.user_id != null){
      // アンケート未回答状態にする
      let set_url = GlobalData.$API_URL + "Form_read"
      axios.post(set_url,
      {
          shakyo:route.params.shakyo,
          file_name:"enqete/answer1.csv"
      }) 
      .then(response => {
          let update_file = response.data.csv_data
          let csv = update_file.split("\n");

          // ヘッダーから体験ユーザーIDの列番地を取得
          let header_row = csv[1].split(" ").filter(Boolean);
          let id_banchi = 0
          for ( const [index, kind] of header_row.entries()) {
              if(kind == "user_id")  id_banchi = index
          }

          // ヘッダーより下の行を確認
          // 該当するユーザーIDがあればOK
          let ok_flg = 0
          for(let c = 2;c<csv.length;c++){
              let csv_row = csv[c].split(" ").filter(Boolean);

              if(csv_row[id_banchi] == GlobalData.user_id) {
                ok_flg = 1
              }
          }

          if(ok_flg == 1){
            enqete_ok.value = 1
          }else{
            // なければアンケート未回答状態にする
            enqete_ok.value = 0
            message.value = GlobalData.$enqete_mikaitou;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "enqete_error";
            contentMessage.value = MessageModal
          }


      })
      .catch(error => {
            if(answer_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "answer_error";
                contentMessage.value = MessageModal
            }else{
                answer_error++
                setTimeout(function(){
                  Form_answer_check()
                },"1000")
            }
      })
  }else{
      enqete_ok.value = 2
  }
}
  */

// 表示フラグ
// 分類1（固定）
// 分類2
// プログラム名（固定）
// 活動内容
// 施設住所
// 活動日数
// 受入先からのコメント
// 添付資料
// その他（特記事項）
// 参加費 ---- ここから下は施設・地域のみ
// 検温等
// マスク着用
// 昼食
// 持ち物
// 制作・寄付活動条件 ---- ここから下は自宅・寄付のみ
// 届け先
// 受付〆切日数 ---- 施設・地域のみ
// 検便 ---- 施設・地域のみ
// 開催地名
// 連絡先
let shosai_disp = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])

// 事前研修（全件）取得
let all_jizen_list = prop.param.jizen

// 実際に表示する事前研修
let jizen = []
let jizen_count = 0

// このプログラムの事前研修No.を格納する配列
let taiken_jizen_no = [];
  
// 体験プログラムの割付事前研修No.を取り出す
if(taiken.jizenkensyu_no != "" && taiken.jizenkensyu_no != null){
  taiken_jizen_no = taiken.jizenkensyu_no.split(',')
}



for(let i = 0;i < all_jizen_list.length;i++){

    let ok_flg = 0
    // 体験プログラムに設定された事前研修No.と同じ研修があれば追加（Okフラグを立てる）
    for(let t = 0;t<taiken_jizen_no.length;t++){
      if(taiken_jizen_no[t] == all_jizen_list[i]["jizen_no"]){
        ok_flg = 1
      }
    }

    // Okフラグが立っている場合でも、参加済の実績である場合、追加しない（OKフラグを下げる）
    if(ok_flg == 1){

            for(let j = 0;j<myjisseki.length;j++){
                let jisseki_kobetsu = myjisseki[j]
                // 実績にプログラム区分２（事前研修）がある場合
                if(jisseki_kobetsu["program_kbn"] == 2){
                    if(jisseki_kobetsu["jokyo"] == '2'){
                        if(all_jizen_list[i]["jizen_id"] == jisseki_kobetsu["program_id"]){
                            ok_flg = 0
                        }
                    }
                }
            }
    }

    if(ok_flg == 0){
      continue
    }

    jizen[jizen_count] = all_jizen_list[i];
    jizen_count++
}

// 事後集会（全件）取得
let all_jigo_list = prop.param.jigo

// 実際に表示する事前研修
let jigo = []
let jigo_count = 0

// このプログラムの事後集会No.を格納する配列
let taiken_jigo_no = [];
  
// 体験プログラムの割付事後集会No.を取り出す
if(taiken.jigosyukai_no != "" && taiken.jigosyukai_no != null){
    taiken_jigo_no = taiken.jigosyukai_no.split(',')
}

for(let i = 0;i < all_jigo_list.length;i++){
    
    let ok_flg = 0
    for(let t = 0;t<taiken_jigo_no.length;t++){
      if(taiken_jigo_no[t] == all_jigo_list[i]["jigo_no"]){
        ok_flg = 1
      }
    }

    if(ok_flg == 0){
      continue
    }

    jigo[jigo_count] = all_jigo_list[i];
    jigo_count++

}



// 体験申込までの流れ（フロー）
// １：体験申込時に事前研修も申し込む
// ２：事前研修の参加が確認できないと体験プログラムに申し込めない
const taiken_flow = prop.param.taiken_flow
let taiken_ok = 0;// 0:申込不可、1:申込可


// アンケート未回答の場合は申込不可
if(enqete_ok.value == 0){
    
}else
// 事前研修が割り付けられていないときはフローに関わらずOK
if(taiken_jizen_no == '' || taiken_jizen_no == [] || taiken_jizen_no == null){
    taiken_ok = 1
}else{
    // フローが1の時
    if(taiken_flow == 1){
        for(let j = 0;j<myjisseki.length;j++){
            let jisseki_kobetsu = myjisseki[j]
            // 実績にプログラム区分２（事前研修）がある場合
            if(jisseki_kobetsu["program_kbn"] == 2){

                for(let t = 0;t<taiken_jizen_no.length;t++){
                    // その実績の事前研修No.が、プログラムに紐づいているものである場合
                    if(jisseki_kobetsu["jizen_no"] == taiken_jizen_no[t]){
                        // その実績が参加済である場合
                        if(jisseki_kobetsu["jokyo"] == '2'){
                            taiken_ok = 1
                        }
                    }
                }
            }
        }
    }else{
        taiken_ok = 1
    }
}


const emit = defineEmits(['call'])
const mode = ref("dsp")
const error_message = ref("")


// 曜日配列
const youbi_list = ["日","月","火","水","木","金","土"]

let TabActive = ref("tab_detail") // どのタブを選択しているか　tab_list：日程一覧、tab_calendar：カレンダー、tab_detail：詳細

// 詳細部分の背景色を切り替えるためのクラス
let contents_color = ref("contentswhite")

// タブ部分の背景色を切り替えるためのクラス
let list_color = ref("tabgray")
let calendar_color = ref("tabgray")
let detail_color = ref("tabblue")

let user_taiken_jyokyo = [] //ユーザーの体験プログラム申し込み状況（ログイン中かつユーザー登録済みの場合に利用）


// 申し込める全ての日時を保存するリスト
let moshikomi_list = ref([])

// 表示するカレンダー（htmlタグをそのまま記述）
let Calendar = ref("")
let CalendarSp = ref("")

// 選択した日時
let select_date = []

// 今日の日付
let today = new Date()

// ユーザーの参加条件で申し込めるかどうかの判断
let joken_moshikomi_flg = ref(true)

// 社協の申込日の関係で申し込めるかどうかの判断
let shakyo_moshikomi_flg = ref(true)

// 自宅・寄付の場合、定員オーバーだったら申し込めない
let seisaku_moshikomi_flg = ref(true)

// 受付〆切日を事業単位(1)で見るか、プログラム単位(2)で見るか
let end_shubetsu = ref(1)

// 受付〆切日（事業単位）
let end_datetime = ref(new Date(today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()+" 23:59:59"))

// 申し込み可能回数を利用するかどうか（1:する、2:しない）
let program_shubetsu = ref(2)

// 申し込み可能回数
let program_count = ref(5)

//---------------- 社協英名から申込開始日を取得し、申し込んでいいかどうかをチェック
let shakyo_error = 0
let shakyo_read = function(){
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
        {shakyo:route.params.shakyo}
        ).then(response => {
        let Shakyo_data =  response["data"]
        shosai_disp.value = Shakyo_data.program_shosai_disp.split(',')
        if(Shakyo_data.moshikomi_start == ""){
                Shakyo_data.moshikomi_start = "00:00:00"
        }
        let moshikomi_date = new Date(Shakyo_data.moshikomi_date+" "+Shakyo_data.moshikomi_start)
        let today = new Date()

        moshikomi_date = moshikomi_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        moshikomi_date = new Date(moshikomi_date);
        moshikomi_date.setHours(moshikomi_date.getHours());

        if (moshikomi_date < today) {
            shakyo_moshikomi_flg.value = true;
            
            // 社協の申し込み可不可を確認した後、自宅・寄付の場合は定員も確認する
            if(taiken.shubetsu == 2){
                // 定員オーバーの場合は申込不可
                if(taiken.seisaku_teiin <= jisseki.length){
                    seisaku_moshikomi_flg.value = false;
                }
            }

        } else {
            shakyo_moshikomi_flg.value = false;
        }
        
              // 受付〆切日の種別を取得
              end_shubetsu.value = response["data"].end_shubetsu

            // 受付〆切日の確認
            if(response["data"].end_date){
              let set_time = " 23:59:59"
              if(response["data"].end_time) {
                set_time = response["data"].end_time
              }
              let end_date = new Date(response["data"].end_date + " "+set_time)
              end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
              end_date = new Date(end_date);
              end_date.setHours(end_date.getHours());
              end_datetime.value = end_date
            }

            // 申し込み可能回数の確認
            if(response["data"].program_shubetsu == 1){
              program_shubetsu.value = response["data"].program_shubetsu
              program_count.value = response["data"].program_count

            }
            /*
            // ユーザー登録後アンケートの実施状況確認
            if(response["data"].enqete_shubetsu == 1){
              setTimeout(function(){Form_answer_check()},"1000")
            }else{
              enqete_ok.value = 2
            }*/
            // 満員・〆切日の確認へ
            over_check()

    })
    .catch(error => {
            if(shakyo_error == 6){
                message.value = error + GlobalData.$axios_error;
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "shakyo_error";
                contentMessage.value = MessageModal
            }else{
                shakyo_error++
                setTimeout(function(){
                  shakyo_read()
                },"1000")
            }
        
    })
}

// ログイン状態の場合は、参加条件とユーザーの学生区分・職業区分を比較
if(GlobalData.gakusei_kbn != null){
        // 小学生の場合
        if(GlobalData.gakusei_kbn == 0){

            if(taiken.joken_syogaku == '〇'){
                joken_moshikomi_flg.value = true;
            }else if(taiken.joken_syogaku != '〇' && taiken.joken_syogaku != 'ー'){
                // 〇年以上が指定されている場合は、同じ学年があればOK
                let gakunen_list = taiken.joken_syogaku.split(",")
                let gakunen_error = false;
                for(let g = 0;g<gakunen_list.length;g++){
                    // 同じ学年があればOK
                    if(GlobalData.gakunen == parseInt(gakunen_list[g])){
                        gakunen_error = true
                    }
                }
                joken_moshikomi_flg.value = gakunen_error;
            }else{
                joken_moshikomi_flg.value = false;
            }
        }

        // 中学生の場合
        if(GlobalData.gakusei_kbn == 1){
            if(taiken.joken_chugaku == '〇'){
                joken_moshikomi_flg.value = true;

            }else if(taiken.joken_chugaku != '〇' && taiken.joken_chugaku != 'ー'){

                // 〇年以上が指定されている場合は、同じ学年があればOK
                let gakunen_list = taiken.joken_chugaku.split(",")
                let gakunen_error = false;
                for(let g = 0;g<gakunen_list.length;g++){
                    // 同じ学年があればOK
                    if(GlobalData.gakunen == parseInt(gakunen_list[g])){
                        gakunen_error = true
                    }
                }
                joken_moshikomi_flg.value = gakunen_error;
            }else{
                joken_moshikomi_flg.value = false;
            }
        }
        
        // 高校生の場合
        if(GlobalData.gakusei_kbn == 2){
            if(taiken.joken_koukou == '〇'){
                joken_moshikomi_flg.value = true;

            }else  if(taiken.joken_koukou != '〇' && taiken.joken_koukou != 'ー'){
                // 〇年以上が指定されている場合は、同じ学年があればOK
                let gakunen_list = taiken.joken_koukou.split(",")
                let gakunen_error = false;
                for(let g = 0;g<gakunen_list.length;g++){
                    // 同じ学年があればOK
                    if(GlobalData.gakunen == parseInt(gakunen_list[g])){
                        gakunen_error = true
                    }
                }
                joken_moshikomi_flg.value = gakunen_error;
            }else{
                joken_moshikomi_flg.value = false;
            }
        }
/*
        // 高専生の場合
        if(GlobalData.gakusei_kbn == 3){
            if(taiken.joken_kousen == '〇'){
                joken_moshikomi_flg.value = true;

            }else if(taiken.joken_kousen != '〇' && taiken.joken_kousen != 'ー'){
                
                // 〇年以上が指定されている場合は、その学年未満なら申込不可
                if(GlobalData.gakunen < parseInt(taiken.joken_kousen)){
                    joken_moshikomi_flg.value = false;

                }else{
                    joken_moshikomi_flg.value = true;
                }
            }else{
                joken_moshikomi_flg.value = false;
            }
        }

        // 専門生の場合
        if(GlobalData.gakusei_kbn == 4){
            if(taiken.joken_senmon == '〇'){
                joken_moshikomi_flg.value = true;
                
            }else if(taiken.joken_senmon != '〇' && taiken.joken_senmon != 'ー'){
                
                // 〇年以上が指定されている場合は、その学年未満なら申込不可
                if(GlobalData.gakunen < parseInt(taiken.joken_senmon)){
                    joken_moshikomi_flg.value = false;

                }else{
                    joken_moshikomi_flg.value = true;
                }
            }else{
                joken_moshikomi_flg.value = false;
            }
        }
*/
        // 専門・大学・大学院生の場合
        if(GlobalData.gakusei_kbn == 5){
            if( taiken.joken_daigaku == '〇'){
                joken_moshikomi_flg.value = true;
            }else if(taiken.joken_daigaku != '〇' && taiken.joken_daigaku != 'ー'){
               
                // 〇年以上が指定されている場合は、同じ学年があればOK
                let gakunen_list = taiken.joken_daigaku.split(",")
                let gakunen_error = false;
                for(let g = 0;g<gakunen_list.length;g++){
                    // 同じ学年があればOK
                    if(GlobalData.gakunen == parseInt(gakunen_list[g])){
                        gakunen_error = true
                    }
                }
                joken_moshikomi_flg.value = gakunen_error;
            }else{
                joken_moshikomi_flg.value = false;
            }
        }
/*
        // 大学院生の場合
        if(GlobalData.gakusei_kbn == 6){
            if( taiken.joken_daigakuin == '〇'){
                joken_moshikomi_flg.value = true;
            
            }else if(taiken.joken_daigakuin != '〇' && taiken.joken_daigakuin != 'ー'){
                
                // 〇年以上が指定されている場合は、その学年未満なら申込不可
                if(GlobalData.gakunen < parseInt(taiken.joken_daigakuin)){
                    joken_moshikomi_flg.value = false;

                }else{
                    joken_moshikomi_flg.value = true;
                }
            }else{
                joken_moshikomi_flg.value = false;
            }
        }
*/
        // その他の場合
        if(GlobalData.gakusei_kbn == 7){
            if((taiken.joken_sonota != '〇' && taiken.joken_sonota != 'ー') || taiken.joken_sonota == '〇'){
                joken_moshikomi_flg.value = true;
            }else{
                joken_moshikomi_flg.value = false;
            }
        }
    
}

if(joken_moshikomi_flg.value == false){
    
    message.value = "このプログラムの参加条件を満たしていません。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "sanka_error";
            contentMessage.value = MessageModal
}


// カレンダーで表示する月を算出する
// 初期値は開催日（自）と同じ年月
let calendar_hyoji_date = new Date(taiken.kaisai_start)
let calendar_year = calendar_hyoji_date.getFullYear()
let calendar_month = calendar_hyoji_date.getMonth() + 1  
const holiday_year_month = calendar_year+"-"+calendar_month+"-01"

let mondate = [31,28,31,30,31,30,31,31,30,31,30,31];//月ごとの最終日
let calendar_kaisai_end = null

/*
// 開催日（至）がnullの場合は、その月の最後までを対象とする
if(taiken.kaisai_end == null){*/

// 祝日は月末まで取得
  let nissu = mondate[calendar_month-1];
    if(calendar_month == 2){
        if(calendar_year%4 == 0){
            if(calendar_year%100 == 0){
                if(calendar_year%400 == 0){
                    nissu = 29;
                }
            }else{
               nissu = 29;
                              
            }
        }
    }
    calendar_kaisai_end = calendar_year+"-"+calendar_month+"-"+nissu
/*}else{
    calendar_kaisai_end = calendar_year+"-"+calendar_month+"-"+nissu
}*/

// 祝日の取得
/*
const holidayJp = require('@holiday-jp/holiday_jp') //between以降に開始日（自・至）を指定する
let holidays = holidayJp.between(new Date(holiday_year_month),new Date(calendar_kaisai_end))
*/

  // タブをクリックしたときの処理
  let TabSelect = function(id){

    let email = GlobalData.$User_email
    let user_id = GlobalData.user_id
    //seltbl.length = 0
    //alert("user_id:"+user_id)
    if (email) {                    // ログインしているかチェック
        if (user_id) {              // ユーザー情報があるかチェック
            mode.value = "sel"
        } else {
            mode.value = "noinfo"   // ユーザー情報を登録していない場合
        }
    } else {
        mode.value = "nologin"        // ログインしていない場合
    }
    // 選択したタブに切り替える（タブ側ではv-ifで表示・非表示を制御）
    TabActive.value = id
    
    // いったんコンテンツの背景を白にする（事前にcontentswhiteクラスを用意）
    contents_color.value = "contentswhite"

    // いったんすべてのタブの背景を灰色にする（事前にtabgrayクラスを用意）
    calendar_color.value = "tabgray"
    detail_color.value = "tabgray"
    list_color.value = "tabgray"

    // アクティブになるタブを青に変更（事前にtabblueクラスを用意）
    if(id == 'tab_list'){
        // 日程一覧を表示
        list_color.value = "tabblue"

        // ログイン・ユーザー登録が済んでいない場合
        // または体験フローが1で事前研修が申し込まれていない場合
        if(mode.value != "sel"|| taiken_ok == 0){
            contents_color.value = "contentsred"
        }
    }else if(id == 'tab_calendar'){
        // カレンダーを表示
        calendar_color.value = "tabblue"
        Calendar_set()

        // ログイン・ユーザー登録が済んでいない場合
        // または体験フローが1で事前研修が申し込まれていない場合
        if(mode.value != "sel"|| taiken_ok == 0){
            contents_color.value = "contentsred"
        }
    }else if(id == 'tab_detail'){
        // 詳細を表示
        detail_color.value = "tabblue"
        
        // 種別が2かつログイン・ユーザー登録が済んでいない場合
        // または体験フローが1で事前研修が申し込まれていない場合
        if((taiken.shubetsu == 2 && mode.value != "sel") || taiken_ok == 0){
            contents_color.value = "contentsred"
        }
    }
  }
  
let douitsu_flg = ref(0) // 同じ日に複数日程を持つ日付が1つでもある場合はこのフラグを立てる
  // 申し込める日時を配列として作成する
  let nittei_set = function(){

    douitsu_flg.value = 0
    
    // 申し込める日時のカウント
    let moshikomi_count = 0
    // 日付のカウント
    let date_count = 0
    let all_count = 0

    // 日程レコードから申し込める日時を作成する
    taiken.nittei.forEach(function(nittei) {

      // 開催日（自・至）から日数を求める
      const start_date = new Date(nittei["kaisai_start"]);

      let set_kaisai_end = nittei["kaisai_end"] 

      // 日程の開催日（至）が未入力の場合、全体の開催日（自）の月末を開催日（至）と判断する
      if(nittei["kaisai_end"] == null){
        set_kaisai_end = kaisai_end
      }
      const end_date = new Date(set_kaisai_end);
      // 差日を求めた上で＋1することで日数になる
      const termDay = ((end_date - start_date) / 86400000) + 1;

      // 申し込める時間帯を取得
      const jikantai_start = nittei["jikantai_start"]
      const jikantai_end = nittei["jikantai_end"]

      // この日程の各日の定員を取得
      const teiin = nittei["teiin"]

      // 開催曜日を取得
      let kaisai_list = []
      if(nittei["kaisai_youbi"] != "" && nittei["kaisai_youbi"] != null){
        nittei["kaisai_youbi"] = nittei["kaisai_youbi"].replace(/､/g, '、')
        kaisai_list = nittei["kaisai_youbi"].split("、")
      }
      // 除外曜日を取得
      let jogai_list = []
      if(nittei["jogai"] != "" && nittei["jogai"] != null){
        nittei["jogai"] = nittei["jogai"].replace(/､/g, '、')
        jogai_list = nittei["jogai"].split("、")
      }
      
      // 除外日を取得
      let jogai_date = []
      if(nittei["jogai_date"] != "" && nittei["jogai_date"] != null){
        jogai_date = nittei["jogai_date"].split("、")
      }
      for(let i = 0;i < termDay;i++){
        let date = new Date();
        if(i != 0) {
          date = start_date.setDate(start_date.getDate() + 1);
        }else{
          date = start_date.setDate(start_date.getDate());
        }
        let set_date = new Date(date)

        let set_year = set_date.getFullYear()
        let set_month = set_date.getMonth() + 1
        let set_day = set_date.getDate()
        let set_youbi = set_date.getDay()

        let moushikomibi = set_year+"/"+set_month+"/"+set_day

        let jogai_day = set_month+"/"+set_day
        

        
        // 開催曜日の指定がある場合
        if(kaisai_list.length != 0){
            
          // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
          if(kaisai_list.includes(youbi_list[set_youbi])) {

          }else{

            // 開催曜日に祝日がある場合
            if(kaisai_list.includes("祝")){
              // 日付が祝日かどうかを確認
              // 祝日でなければスルー
              if(!holidays_list.includes(moushikomibi)) continue
              
            }else{
                continue
            }
          }
        }
        // 除外曜日の指定がある場合
        if(jogai_list.length != 0){
          // 除外曜日に指定した曜日に該当する日の場合
          // 飛ばして次へ
          if(jogai_list.includes(youbi_list[set_youbi])) continue

          // 除外曜日に祝日がある場合
          if(jogai_list.includes("祝")){
            // 日付が祝日かどうかを確認
            // 祝日であれば飛ばして次へ
            if(holidays_list.includes(moushikomibi)) continue
            
          }
        }

        // 除外日の指定がある場合
        if(jogai_date.length){
          
          // 除外日に該当する日の場合
          // 飛ばして次へ
          if(jogai_date.includes(jogai_day)) continue
        }

        let check_date = set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2);
        
        // この申込日時を追加すべきかどうか（0：追加する、1：追加しない）
        let add_flg = 0
        moshikomi_list.value.filter( function (value) {
          if(check_date == value.check_date && nittei["jikantai_start"] == value.jikantai_start && nittei["jikantai_end"] == value.jikantai_end){
            // 同じ日時がすでにある場合は飛ばす
            add_flg = 1

          }
        })
        
        

        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        set_date = new Date(set_date)
        set_date.setHours(0, 0, 0, 0);//0時0分0秒に設定

        let today = new Date()
        today = today.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
        today = new Date(today)
        today.setHours(0, 0, 0, 0);//0時0分0秒に設定
        // 開催日と今日の日付を比較して日数を取得
        var checkDay = (set_date - today) / 86400000 ;

        let set_nissu = 1

        // 受付〆切日時がプログラム単位の場合
        if(end_shubetsu.value == 2){
            // 受付〆切日が設定されていない場合
            if(!taiken.shimekiri_date){
                set_nissu = taiken.shimekiri_nissu
            }
        }
        

        if (checkDay < set_nissu) {
            add_flg = 1
            
        }
       // alert(add_flg+"\n"+(checkDay)+"/"+(taiken.shimekiri_nissu)+"\n"+today+"\n"+set_date+"\n"+(!((checkDay) < taiken.shimekiri_nissu)))


        // 追加済みの日時であれば飛ばして次へ
        if(add_flg == 0){ 
          let moshikomi_flg = 0 // 0：申し込みなし、1:体験プログラムに申し込み済み、2：事前研修に申し込み済み

          // ログイン中かつユーザー登録済みの場合、申し込むユーザーは該当日に申し込み済みか確認する
          if(user_taiken_jyokyo.length != 0){
            for(let j = 0;j<user_taiken_jyokyo.length;j++){
              let kaisai_date = new Date(user_taiken_jyokyo[j].kaisai_date)
              let check_kaisai_date = kaisai_date.getFullYear()+"-"+('00'+(kaisai_date.getMonth()+1)).slice(-2)+"-"+('00'+kaisai_date.getDate()).slice(-2);
              
              // 申し込み済みの場合はフラグを立てる（キャンセルした体験プログラムは除く）
              if(check_kaisai_date == check_date && user_taiken_jyokyo[j].jokyo != 9){
                // 実績が事前研修の場合
                if(user_taiken_jyokyo[j].program_kbn == 2){
                    if(user_taiken_jyokyo[j].syurui == 3){
                        // 動画視聴の場合は申込無しとする
                    }else{
                        // 動画視聴以外の場合はフラグを立てる
                        moshikomi_flg = user_taiken_jyokyo[j].program_kbn

                    }
                }else{
                    moshikomi_flg = user_taiken_jyokyo[j].program_kbn
                }
              }
            }
          }

          // Dateは並び替え用のdate、申し込み状況確認用のcheck_date、実際に表示するhyoji_dateを用意
          moshikomi_list.value[moshikomi_count] = {"all_count":i,"moshikomi_count":moshikomi_count,"date":set_date,"check_date":check_date,"hyoji_date":moushikomibi,"youbi":youbi_list[set_youbi],"jikantai_start":jikantai_start,"jikantai_end":jikantai_end,"ninzu":0,"teiin":teiin,"moshikomi_flg":moshikomi_flg}
          moshikomi_count++
        }
       
      }
    });

    // 日付順で並び替え
    moshikomi_list.value.sort((a, b) => a.date - b.date);

    let before_date = ""
    let date_bango = 0 // 日付ごとの番号

    // 同じ日付には同じ番号を振るようにする
    for(let md = 0;md<moshikomi_list.value.length;md++){
        if(moshikomi_list.value[md].hyoji_date != before_date){
            date_bango = date_bango + 1
            
        }else{
            // 同一日程フラグON
            douitsu_flg.value = 1
        }
        //alert(before_date = moshikomi_list.value[md].hyoji_date)
        before_date = moshikomi_list.value[md].hyoji_date
        moshikomi_list.value[md].date_bango = date_bango
    }


    // 申込状況レコードから申し込まれた日時の人数を確認する
    jisseki.forEach(function(jyokyo) {
      // 申し込める日時配列内を、申込状況レコードの開催日・開催時間（自）でフィルター検索
      moshikomi_list.value.filter( function (value) {
          if(jyokyo["kaisai_date"] == value.check_date 
          && jyokyo["jikantai_start"] == value.jikantai_start){
            // 合致した条件の人数を加算する
            value.ninzu =  value.ninzu + jyokyo["ninzu"] 
          }
      })
    });
    // ローディングアイコンストップ
    emit('call',{ cmd:'loading_end_noreload' })
  }
  
  // カレンダーを表示する
  let Calendar_set = function(){
    
    const date = new Date(calendar_year,calendar_month,1)
    const year = date.getFullYear()
    const month = date.getMonth() 

    const startDate = new Date(year, month - 1, 1) // 月の最初の日を取得
    const endDate = new Date(year, month,  0) // 月の最後の日を取得
    const endDayCount = endDate.getDate() // 月の末日
    const startDay = startDate.getDay() // 月の最初の日の曜日を取得
    let dayCount = 1 // 日にちのカウント
    let calendarHtml = '' // HTMLを組み立てる変数（PC）
    let spHtml = '' // HTMLを組み立てる変数（スマホ）
    
    // リスト全体の番号を割り振る
    for(let i = 0;i<moshikomi_list.value.length;i++){
        moshikomi_list.value[i].all_count = i
    }

    for (let w = 0; w < 6; w++) {

        // 1週間のうち、日付を入れたカラムを判定する
        let setCount = 0

        // PC用とスマホ用の2つを用意
        let set_html = '<div id="calendar_column_area" >'
        let set_sp_html = '<div id="calendar_column_area" >'

        for (let d = 0; d < 7; d++) {
          set_html += '<div class="'
          set_sp_html += '<div class="'
            if(d == 0) {
                set_html += 'calendar_column_left'
                set_sp_html += 'calendar_column_left'
            }else if(d == 6){
                set_html += 'calendar_column_right'
                set_sp_html += 'calendar_column_right'

            }else{
                set_html += 'calendar_column'
                set_sp_html += 'calendar_column'
              
            }
            set_html += '">'
            // spの閉じは後で
            if (w == 0 && d < startDay) {
                
                set_sp_html += '">'

                // 1行目で1日の曜日の前
                set_html += '<div class="column_date_blank"></div>'
                set_sp_html += '<div class="column_date_blank"></div>'
            } else if (dayCount > endDayCount) {
                
                set_sp_html += '">'

                // 末尾の日数を超えた
                set_html += '<div class="column_date_blank"></div>'
                set_sp_html += '<div class="column_date_blank"></div>'
            } else {
                

                // 申込リスト内に日付がある場合は申し込まれた人数を表示
                // 現在表示する日付をセット
                let setDate = calendar_year+"-"+('00'+(calendar_month)).slice(-2)+"-"+('00'+dayCount).slice(-2)
                let checkHoliday = calendar_year+"/"+calendar_month + "/"+ dayCount
              
                set_sp_html += '"'
                set_sp_html += ' id="'+setDate+'"'
                // スマホの場合はここで、選択した日付が存在するなら背景色を変える
                if(select_date.findIndex(({kaisai_date}) => kaisai_date == setDate) != -1){
                    set_sp_html += 'style="background-color:#AFA;"'
                }
                set_sp_html += '>'
                // 日付を入力
                set_html += '<div class="column_date">'

                set_sp_html += '<div class="column_date"  ';
                set_sp_html += '>'
              
                set_html += '<div class="column_date_day"><span '
               // set_sp_html += '<div class="column_date_day" id="'+setDate+'" ><span  id="'+setDate+'" '
                set_sp_html += '<div class="column_date_day" ><span '
                // 祝 or 日なら赤
                if(holidays_list.includes(checkHoliday) || d == 0){
                  set_html += "style='color:red'"
                  set_sp_html += "style='color:red'"
                }else if(d == 6){
                  // 土なら青
                  set_html += "style='color:blue'"
                  set_sp_html += "style='color:blue'"
                }
              
                set_html += '/>'
              set_sp_html += '/>'
              
              set_html +=  dayCount
              set_sp_html +=  dayCount
              
              set_html += '</span></div>'
              set_sp_html += '</span></div>'

            let before_date = 0
            moshikomi_list.value.filter( function (value) {

                // 申し込める日付リストに存在していたら時間帯（PC）or申込可不可マーク（スマホ）を表示
                  if(setDate == value.check_date ){

                    set_html += '<div class="column_date_time">'
                        
                    // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                    if(value.check_date != before_date){
                        set_sp_html += '<div class="column_date_time" >'
                    }
                      // 時間帯

                      // 未ログイン・未ユーザー登録の場合
                      if(mode.value == 'nologin' || mode.value == 'noinfo' ){
                        // PCの場合は時間帯と人数を表示
                        set_html += '<div >'
                        set_html += TimeSetting(value.jikantai_start) +'～'+TimeSetting(value.jikantai_end)
                          set_html += " <b style='font-size:15px;margin-left:10px;"
                          
                          // 申込人数が定員より少ないときは青色
                          if(value.ninzu < value.teiin){
                              set_html += "color:blue"
                          }else{// 申込人数が定員のときは赤色
                              set_html += "color:red"
                          }
                          
                          set_html += "'>"
                          // 申込人数 / 定員
                          let nokori_ninzu = (value.teiin - value.ninzu)
                          if(nokori_ninzu < 0){
                            nokori_ninzu = 0
                          }
                          if(value.teiin < 999){
                            set_html += nokori_ninzu
                          }

                          // 定員がnullの場合は表示しない
                          /*
                          if(value.teiin != null){
                            set_html +=  "/"+ value.teiin
                          }*/
                          set_html += '</b></div>'

                        // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                        if(value.check_date != before_date){
                            // スマホの場合は申込可不可（● or ×）を表示
                            set_sp_html += '<div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;" ';   
                            if(value.ninzu < value.teiin){
                                //set_sp_html += 'id="'+setDate+'"';
                            }
                            set_sp_html += '>'
                            set_sp_html += " <img style='width:50%' src='../../../img/"
                            
                            // 申込人数が定員より少ないときは青色の「●」
                            if(value.ninzu < value.teiin){
                                set_sp_html += "OK.png' id='"+setDate+"'/>"
                            }else{// 申込人数が定員のときは赤色の「×」
                                set_sp_html += "NG.png'/>"
                            }
                            
                            set_sp_html += '</div>'
                        }
                      }else 
                      // 他に申し込んでいるプログラムがないなら時間帯（PC）or申込可不可マーク（スマホ）を表示
                      if(value.moshikomi_flg == 0){

                        // PCの場合は時間帯を表示し、日付をクリックできるかどうかを判定する
                          set_html += '<div class="set_id'+value.all_count+'"';
                          set_html += 'id="'+value.all_count+','+value.check_date+','+value.jikantai_start+','+value.jikantai_end+','+value.ninzu+','+value.teiin+','+value.date_bango+'"'
                          set_html += 'style="display: flex;align-items: center;'
                               
                          
                          // カレンダー表示時、選択した日付が存在するなら背景色を変える
                          if(select_date.findIndex(({bango}) => bango == value.all_count) != -1){
                            set_html += "background-color:#AFA;"
                          }

                          // 申込人数が定員より少ないときは下線とカーソルを入れる（クリック可能なことを強調）
                          if(value.ninzu < value.teiin){
                            set_html += "cursor:pointer;border-bottom:1px solid #000;"
                          }

                          set_html += '">'
                          set_html += TimeSetting(value.jikantai_start) +'～'+TimeSetting(value.jikantai_end)

                          set_html += " <b style='font-size:15px;margin-left:10px;"
                          
                          // 申込人数が定員より少ないときは青色
                          if(value.ninzu < value.teiin){
                              set_html += "color:blue"
                          }else{// 申込人数が定員のときは赤色
                              set_html += "color:red"
                          }
                          
                          set_html += "'>"
                          // 申込人数 / 定員
                          let nokori_ninzu = (value.teiin - value.ninzu)
                          if(nokori_ninzu < 0){
                            nokori_ninzu = 0
                          }
                          if(value.teiin < 999){
                            set_html += nokori_ninzu
                          }
/*
                          // 定員がnullの場合は表示しない
                          if(value.teiin != null){
                            set_html +=  "/"+ value.teiin
                          }*/
                          set_html += '</b></div>'

                          // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                          if(value.check_date != before_date){
                            // スマホの場合は申込可不可（● or ×）を表示し、選択できるかどうかを判定する
                            set_sp_html += '<div class="set_id'+value.all_count+'" ';   
                            if(value.ninzu < value.teiin){
                                set_sp_html += 'id="'+setDate+'"';
                            }
                            set_sp_html += 'style="width:100%;height: 100%;display: flex;align-items: center;justify-content: center;'
                            
                            
                            set_sp_html += '">'
                            set_sp_html += " <img style='width:50%' src='../../../img/"
                            
                            // 申込人数が定員より少ないときは青色の「●」
                            if(value.ninzu < value.teiin){
                                set_sp_html += "OK.png' id='"+setDate+"'/>"
                            }else{// 申込人数が定員のときは赤色の「×」
                                set_sp_html += "NG.png'/>"
                            }
                            
                            set_sp_html += '</div>'
                        }
                        
                      }else{

                        // 申込済みの場合、PCは申込済みであることを明記する
                        set_html += '<span style="color:red">申込済'
                        
                        if(value.moshikomi_flg == 1){
                          set_html += '(体)'
                        }else{
                          set_html += '(研)'
                        }
                        
                        set_html += '</span>'
                        
                        // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                        if(value.check_date != before_date){
                            // スマホは×を表示
                            set_sp_html += " <img style='width:50%' src='../../../img/NG.png'>"
                        }
                      }
                      set_html += '</div>'
                      
                    // スマホの場合、前の日付が今から入力する日付と同じ日なら、重複を防ぐために入力しないようにする
                    if(value.check_date != before_date){
                      set_sp_html += '</div>'
                    }

                    // 表示中の日付を取得
                    before_date = setDate
                  }
              })
                set_html += '</div>'
                set_sp_html += '</div>'

              dayCount++
              setCount++
            }
            set_html += '</div>'
            set_sp_html += '</div>'
        }
        set_html += '</div>'
        set_sp_html += '</div>'

        // 日付の入ったカラムが1個でもあれば行として追加
        if(setCount !=0){
          calendarHtml += set_html
          spHtml += set_sp_html
        }
    }

    Calendar.value = calendarHtml
    CalendarSp.value = spHtml
    
  }

  // カレンダーの月を加算・減算し、再度カレンダーを表示する
  let Change_month = function(num){
    calendar_month = calendar_month + num
    if(calendar_month == 13){
         calendar_month = 1
    }else if(calendar_month == 0){
        calendar_month = 12
    }
    Calendar_set()
  }

  // カレンダー上の時間帯をクリックした時（PC）
  let htmlColumnClick = function(e){
        let clicked = e.target.id

        if(clicked == "") return

        let Click_array = clicked.split(",")

        // 参加人数が定員以上であればそれ以上申し込めないようにする
        if(Click_array[4] >= Click_array[5]){
            return;
        }

        Set_id(Click_array[1],Click_array[2],Click_array[3],Click_array[0],2,Click_array[6])
}
  
  // 選択した日時を保存
  let Set_id = function(kaisai_date0,jikantai_start0,jikantai_end0,num,set_type,date_bango){

    // ログイン中かつユーザー登録済みの場合のみ選択可能
    if(mode.value == 'sel'){
        let set_list = {"bango":num,"date_bango":date_bango,"kaisai_date":kaisai_date0,"jikantai_start":jikantai_start0,"jikantai_end":jikantai_end0}

        let set_back_color = "#AFA"

        // 配列内に選択した番号があるかどうか
        // 番号が存在しない場合は追加
        if(select_date.findIndex(({bango}) => bango == num) == -1){
            
            // 選択できる最大日数
            let max_day = taiken.nissu_max

            // 参加代行リストに値が入力済みの場合はチェックを挟む
            if(select_date.length != 0){
                // 現在の選択日数＋1日が最大日数を超える場合
                if(max_day == select_date.length){
                
                    message.value = max_day+"日以上は選択できません。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "nissu_error";
                    contentMessage.value = MessageModal
                    return
                }

                // 同一日申込が不可の場合
                if(taiken.nissu_douitsu == false){

                    // 選択済みの日付が含まれていたらエラー
                    if(select_date.findIndex(({kaisai_date}) => kaisai_date == kaisai_date0) != -1){
                        message.value = "この体験プログラムでは同一日申込ができません。";
                        message_cat.value = 0;
                        message_flag.value = true;
                        message_method.value = "nissu_error";
                        contentMessage.value = MessageModal
                        return
                    }
                }
            }

            select_date.push(set_list)
        }else{

            // 番号が存在する場合は削除
            for(let d = 0;d < select_date.length;d++){
                if(select_date[d].bango == num){
                    select_date.splice(d,1)
                }
            }
            set_back_color = "#FFF"
        }

        // IDを元に背景色を変更
        if(set_type == 1){
            // set_type = 1（リストをクリック）
            let obj = document.getElementById('set_id'+num)
            obj.style.backgroundColor = set_back_color
        }else if(set_type == 2){
            // set_type = 2（カレンダー（PC）をクリック）
            let obj = document.getElementsByTagName("*")

            for(let o in obj){
                if(obj[o].className == 'set_id'+num){
                    obj[o].style.backgroundColor = set_back_color
                }
            }
        }else if(set_type == 3){
            // set_type = 3（カレンダー（スマホ）で選択
            let obj = document.getElementById(kaisai_date0)
            obj.style.backgroundColor = set_back_color
        }
    }
}

// カレンダー上のマーク（●）をクリックした時（スマホ）
let htmlColumnClickSp = function(e){
    let clicked = e.target.id

    
    if(clicked == "") return

    let disp_moshikomi_time = []
    let moshikomi_OK_count = 0
    for(let m = 0;m<moshikomi_list.value.length;m++){
        // 選択した日が申込日に存在するかどうか
        if(moshikomi_list.value[m].check_date == clicked){
            disp_moshikomi_time[disp_moshikomi_time.length] = moshikomi_list.value[m]
            // 定員がオーバーしてなければ申し込み可能
            if(moshikomi_list.value[m].teiin > moshikomi_list.value[m].ninzu){
                moshikomi_OK_count++
            }
        }
    }

    // 申し込める日があるならウィンドウを開く
    if(moshikomi_OK_count != 0){
        smart_calendar_area.value = true
        paramCalendar = {"clicked":clicked,"moshikomi":disp_moshikomi_time,"select_date":select_date,"mode":mode.value}
        contentCalendar.value = UserCalendarSmart
    }

}

// 指定した日付で申し込む
const moshikomi_set = function(){

    emit('call',{ cmd:'page_scroll' })
    
    if(taiken.shubetsu==1){
        // 施設・地域活動の場合
        if(TabActive.value == 'tab_detail'){
            TabSelect('tab_list')
            return

        }
    }

    if(mode.value == 'nologin' ){
        message.value = "申込みにはログインが必要です。";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "login_error";
        contentMessage.value = MessageModal
        return
    }
    
    if(mode.value == 'noinfo' ){
        message.value = "申込みの前にユーザー情報（プロフィール）の登録を行ってください。";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "user_error";
        contentMessage.value = MessageModal
        return
    }

 
    // 施設・地域活動の場合
    if(taiken.shubetsu==1){
        
        // 要素が2つ以上ある場合は番号順で並び替え
        if(select_date.length != 1){
            select_date.sort((a, b) => a.bango - b.bango);
        }

        // 選択できる最小日数
        let min_day = taiken.nissu_min
        // 選択できる最大日数
        let max_day = taiken.nissu_max

        if(min_day == null || min_day == ""){
            min_day = 1
        }
        if(max_day == null || max_day == ""){
            max_day = 99
        }

        // 最大日数と最小日数が同じ場合
        if(max_day == min_day){
            // 選択した日数が最大日数に満たない場合はエラー
            if(select_date.length < max_day){
                
                message.value = "日数は"+max_day+"日分選択してください。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "nissu_error";
                contentMessage.value = MessageModal
                return
            }

        }else{

            // 最大日数と最小日数が別の場合
            if(min_day <= select_date.length && select_date.length <= max_day){
                // 選択した日数が最小～最大の間ならOK
                
            }else{

                // 選択した日数が最小～最大の間ではない場合はエラー
                if(taiken.nissu_min == null || taiken.nissu_min == ""){
                    message.value = "日数は"+max_day+"日以内で選択してください。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "nissu_error";
                    contentMessage.value = MessageModal

                }else if(taiken.nissu_max == null || taiken.nissu_max == ""){
                    message.value = "日数は"+min_day+"日以上選択してください。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "nissu_error";
                    contentMessage.value = MessageModal

                }else{
                    message.value = "日数は"+min_day+"～"+max_day+"日の間で選択してください。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "nissu_error";
                    contentMessage.value = MessageModal
                }
                return
            }

        }

        let error_count = 0

        // 日数条件が連続の場合
        if(taiken.nissu_joken == 1){

            let jogai = taiken.nissu_jogai
            //jogai = false
            
            // 除外日を飛ばす場合
            if(jogai == true){

                // 比較する番号（前の番号）
                let before_bango = 99999999999  

                
                // 連番ではない場合はエラー
                for(let d = 0;d < select_date.length;d++){
                    if(before_bango != 99999999999 ) {
                        if(parseInt(select_date[d].date_bango) == parseInt(before_bango)+1){
                        }else{
                            error_count = error_count + 1

                        }
                    }
                    before_bango = select_date[d].date_bango
                }
                /*
                let before_date = ""
                // 連番ではない場合はエラー
                for(let d = 0;d < select_date.length;d++){
                    if(before_bango != 99999999999 ) {
                        if(parseInt(select_date[d].date_bango) == parseInt(before_bango)+1){
                        }else{
                            // 同一日申込可能の場合
                            if(taiken.nissu_douitsu == true){
                                // 前にチェックしたと別日（同一日ではない）ならエラー
                                if(select_date[d].kaisai_date != before_date){
                                    error_count = error_count + 1
                                }
                            }else{
                                error_count = error_count + 1
                            }
                        }
                    }
                    before_date = select_date[d].kaisai_date
                    before_bango = select_date[d].date_bango
                }
                    */
                
                if(error_count != 0){
                    
                    message.value = "連続した日付を選択してください。";
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "nissu_error";
                    contentMessage.value = MessageModal
                    return;
                }
            }else{
                // 除外日を飛ばさない場合
                // 比較する日付（前の日付）
                let before_date = ""    

                // 日付が順番ではない場合はエラー
                for(let d = 0;d < select_date.length;d++){
                    if(before_date != "" ) {
                        // 確認する日付と比較する日付をDate型に変換
                        let check_kaisai_date = new Date(select_date[d].kaisai_date)
                        let check_before_date = new Date(before_date)
                        check_before_date.setDate( check_before_date.getDate() +1 )//確認する日付を1日進める

                        if(check_kaisai_date.getTime() == check_before_date.getTime()){
                        }else{
                        error_count = error_count + 1
                        }
                    }
                    before_date = select_date[d].kaisai_date
                }

                if(error_count != 0){
                    message.value = "除外日及び除外曜日を飛ばさずに、連続した日付を選択してください。"
                    message_cat.value = 0;
                    message_flag.value = true;
                    message_method.value = "nissu_error";
                    contentMessage.value = MessageModal
                    return;
                }

            }

        }else{
            // 自宅・寄付活動の場合
        }
    }

    // 特にエラーがなければ親コンポーネントに日付を含む配列を送って確認画面へ
    emit('call',{cmd:'moshikomi',shosai:taiken,select_date:select_date,user_jyokyo:user_taiken_jyokyo})

}

// 満員や〆切日のチェック
let over_check_error = 0
let over_check = function(){
        // 定員フラグ（１の時は満員）
        let teiin_flg = taiken.teiin_flg

        let check_shimekiri = end_datetime.value
        
                
        // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されてる場合はそちらを確認する
        if(end_shubetsu.value == 2 && taiken.shimekiri_date){
            let shimekiri = new Date(taiken.shimekiri_date)

            shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            shimekiri = new Date(shimekiri);
            shimekiri.setHours(shimekiri.getHours());

            check_shimekiri = shimekiri

        }else if(end_shubetsu.value == 1){
            
            // 受付〆切日種別が1（事業単位）なら事業単位の日付を入力
            let shimekiri = new Date(end_datetime.value)

            shimekiri = shimekiri.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            shimekiri = new Date(shimekiri);
            shimekiri.setHours(shimekiri.getHours()+9);

            check_shimekiri = shimekiri
        }else{
            // 受付〆切日種別が2（プログラム単位）かつプログラムに〆切日が設定されていない場合は今日の日付を入力
            check_shimekiri = new Date()
        }
        if (teiin_flg == 1) {
        
            // ローディングアイコンストップ
            emit('call',{ cmd:'loading_end_noreload' })
            message.value = "このプログラムは満員です。";
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "teiin_end";
            contentMessage.value = MessageModal
        }else{
            if (check_shimekiri < today) {
        
                // ローディングアイコンストップ
                emit('call',{ cmd:'loading_end_noreload' })
                message.value = "このプログラムは申し込みを締め切っています。";
                message_cat.value = 0;
                message_flag.value = true;
                message_method.value = "moshikomi_end";
                contentMessage.value = MessageModal
            }else{
                

                if(prop.param.type != undefined){
                    // 初期表示タブが指定されていたらそちらを表示
                    TabSelect(prop.param.type)
                }else{
                    // 特に指定がない場合は詳細
                    TabSelect('tab_detail')
                }
                
                if (GlobalData.$User_email) { // ログインしているかチェック
                    if (GlobalData.user_id) { // ユーザー情報があるかチェック
                        
                        // ログイン中かつユーザー情報登録済みであれば実績データを取得
                        axios.post(GlobalData.$API_URL + "Taikenuser_Jisseki",
                        {
                        taikenuser_id: GlobalData.user_id
                        },GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
                        .then(response => {

                            if(response.data["status"] == 1){
                                
                                    
                            }else{
                                user_taiken_jyokyo = response.data.jisseki
                                let sanka_flg = 0
                                let sanka_count = 0
                                let before_id = 0
                                // 締切前なら体験プログラムの申し込み状況を確認
                                // ついでに申込済みの体験プログラムをカウント
                                for(let u = 0;u<user_taiken_jyokyo.length;u++){

                                    if(user_taiken_jyokyo[u].jokyo != 9){
                                        if(taiken.taiken_id == user_taiken_jyokyo[u].program_id){
                                            sanka_flg = 1
                                        }
                                        
                                        if(before_id != user_taiken_jyokyo[u].program_id){
                                            if(user_taiken_jyokyo[u].program_kbn == 1){
                                            sanka_count++
                                            }
                                        }
                                        before_id = user_taiken_jyokyo[u].program_id
                                    }
                                }

                                if(sanka_flg == 1){
        
                                    // ローディングアイコンストップ
                                    emit('call',{ cmd:'loading_end_noreload' })
                                    message.value = "このプログラムは申込済です。";
                                    message_cat.value = 0;
                                    message_flag.value = true;
                                    message_method.value = "sanka_zumi";
                                    contentMessage.value = MessageModal
                                }else{
                                    
                                    // 申し込み回数の上限が決まっている場合
                                    if(program_shubetsu.value == 1){

                                        // 申し込み回数がすでに上限以上の場合は進入不可
                                        if(program_count.value <= sanka_count ){
                                            
                                            // ローディングアイコンストップ
                                            emit('call',{ cmd:'loading_end_noreload' })
                                            message.value = "申し込み回数の上限に達しています。\n※このプログラムに参加したい場合は、他のプログラムを１つキャンセルする必要があります。"
                                            message_cat.value = 0;
                                            message_flag.value = true;
                                            message_method.value = "sanka_zumi";
                                            contentMessage.value = MessageModal
                                            return
                                        }

                                    }
        
                                    // 日程を元に申し込み日をセッティング
                                    nittei_set()

                                }

                            }
                        })
                        .catch(error => {
                            if(over_check_error == 6){
                                message.value = error + GlobalData.$axios_error;
                                message_cat.value = 0;
                                message_flag.value = true;
                                message_method.value = "over_check_error";
                                contentMessage.value = MessageModal
                            }else{
                                over_check_error++
                                setTimeout(function(){
                                    over_check()
                                },"1000")
                            }
                        })
                    }else{
        
                        mode.value = "noinfo"
                        // 日程を元に申し込み日をセッティング
                        nittei_set()
                    }
                }else{
        
                    mode.value = "nologin"
                    // 日程を元に申し込み日をセッティング
                    nittei_set()
                }
            }
        }
    }
    
let EndDateTimeSetting = function(changedate){
  
  let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours()+9);

    //return date;
    return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+")"+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
}
  //年月日＋時間の表示を整える(EU時間)
  let EuDateTimeSetting = function(changedate){
     /*
     let date = Date.parse(changedate);
     let set_date = new Date(date);
     set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     set_date = new Date(set_date);
     set_date.setHours(set_date.getHours()-8);
 */
     let eudate = Date.parse(changedate);
     let eu_set_date = new Date(eudate);
     eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     eu_set_date = new Date(eu_set_date);
     eu_set_date.setHours(eu_set_date.getHours()-9);
 
     const set_month = eu_set_date.getMonth()+1
 
     // 日時から日と時をそれぞれ抜き出す
     let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
     let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
 
     let return_date = new Date(day + " "+time)
     return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     return_date = new Date(return_date);
 
     return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+")"+ ('00'+return_date.getHours()).slice(-2)+":"+('00'+return_date.getMinutes()).slice(-2)
  }
//------------------- リンク
const home = () => { router.push('/'+cityname+'/Taiken') }
const ichiran = () => {
    router.push('/'+cityname+'/Taiken/Program')
}
const userinfo = () => {
    emit('call',{ cmd:'user_toroku' })
}

const login = () => {
    emit('call', { cmd:'login',id:''})
}

const jizen_list = () =>{
    router.push('/'+cityname+'/Taiken/Jizen')
}

//------------------- Googlemap（外部リンク）へ
const jusho = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

//------------------- 添付資料（外部リンク）へ
const shiryo_open = (url)  => { 
    window.open(url,"_blank")

}

// 所属社協へ移動する
const move_shozoku = () =>{
    location.href=location.protocol+'//'+location.host+"/"+GlobalData.shakyo_code+"/Taiken"
}

// ユーザー登録後アンケートへ移動
let move_enqete = function(){
  router.push('/'+cityname+'/Taiken/enqete/1') 
}

const shiryo_open_sp = (url)  => { 
//    window.open(url,"_blank")

    location.href = url
}

    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる

        // message_methodの内容に応じてこちら（親コンポーネント）の関数を起動する
        if(message_method.value == "login_error"){
            // 未ログインの場合はログイン画面へ
            emit('call', { cmd:'login',id:''})
        }else if(message_method.value == "user_error"){
            // ユーザー未登録の場合はユーザー登録画面へ
            userinfo()
        }else if(message_method.value=="sanka_zumi"){
            router.push('/'+cityname+'/Taiken/mypage')
        }else if(message_method.value=="moshikomi_end" || message_method.value == "teiin_end" || message_method.value == "sanka_error"){
            router.push('/'+cityname+'/Taiken')
        }else  if(message_method.value == "enqete_error"){
            // アンケート未回答の場合はアンケート画面へ
            move_enqete()
        }

        
    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }

    /* 初期処理 */
    // ページトップまでスクロール
    emit('call',{ cmd:'page_scroll' })

//-------------- 子コンポーネントの呼び出しに応じて処理を呼び出す -------------------
const call = function(proc) {
        switch(proc.cmd) {
            case "close":
              
              // カレンダー日時ウィンドウを閉じる
              smart_calendar_area.value = false

              break
            
            case "set":

                let set_moshikomi = proc.moshikomi
              
                Set_id(proc.date,set_moshikomi.jikantai_start,set_moshikomi.jikantai_end,set_moshikomi.all_count,3,set_moshikomi.date_bango)
                // カレンダー日時ウィンドウを閉じる
                smart_calendar_area.value = false

              break
            
            default:
                break
        }
    }


    let manual_open = function(){
      let url = "https://zest-newsprint-e3e.notion.site/161c0be34f8f80fc87baf85432ed7220"
      window.open(url,"_blank")
  }

  // Q&Aを開く
  const qanda_open = () =>{

    let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
    window.open(url,"_blank")
  }        
      

    // 初期処理：祝日取得→社協情報呼び出し

    // 祝日を取得
    const calendarId = 'japanese__ja@holiday.calendar.google.com'
    const calendarApiUrl = 'https://www.googleapis.com/calendar/v3/calendars/'
    const apiKey = GlobalData.$holiday_key
    function loadGoogleCalendarApi() {
        gapi.client.init({
            apiKey: apiKey,
        }).then(() => {
            return gapi.client.request({
            path: calendarApiUrl + encodeURIComponent(calendarId) + '/events'
            })
        }).then((res) => {
            
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            
            // Googleカレンダーで祝日にされてしまっているもの
            let not_holiday = ["雛祭り","クリスマス","母の日","七五三","節分","七夕"]
            const items = res.result.items
            for(let i = 0; i < items.length; i++){
                // 今年と来年の祝日だけ取得
                if(items[i].start.date.substring(0,4) == set_date.getFullYear() ||
                    items[i].start.date.substring(0,4) == (set_date.getFullYear()+1) ){

                        // 祝日ではない場合は挿入しない
                        if(!not_holiday.includes(items[i].summary)){
                            let set_date = new Date(items[i].start.date)
                            let set_year = set_date.getFullYear()
                            let set_month = set_date.getMonth() + 1
                            let set_day = set_date.getDate()
                            holidays_list[holidays_list.length] = set_year+"/"+set_month+"/"+set_day
                        }

                }
            }
        
            // 社協呼び出し
        shakyo_read()
            
        })
    }
    gapi.load('client', loadGoogleCalendarApi)
</script>

<style scoped>
.hov {
  background-color: white;
  cursor: default;
}
.hov:hover {
  background-color: wheat;
  cursor: pointer;
}
.joken_table{
    text-align: center;
    width: 70%;
    table-layout: fixed;
}
.joken_table tr td{
    text-align: center;
    border: 1px solid #000;
}

    #tab {
        width: 100%;
        margin: auto;
    }
    #tab_detail{
        border-radius: 5px 0 0 0;
    }
    #tab_calendar{
        border-radius: 0 5px 0 0;
    }
    #tab_list {
        border-left: 2px solid #FFF;
        border-right: 2px solid #FFF;
    }
  .tabMenu {
    display: flex;
    padding: 0;
    margin-bottom:0;
   }

   .tabMenu li {
      list-style:none;
      width: 33%;
      padding: 10px 20px;
      cursor: pointer;
  }
  
  .tabblue{
      color: #fff;
      background-color: #06F;
  }
  .tabgray{
      color: #fff;
      background-color:#b3b3b3 ;
  }
  .contentswhite{
      background-color: #fff;
  }
  .contentsred{
      background-color: mistyrose;
  }

  .tabContents {
    border:1px solid rgb(170,170,170);
  }

  .list_column_left{
    border-left:1px solid #000;
    border-right:1px solid #000;
    width:30%;
  } 
  .list_column_standard{
    border-right:1px solid #000;
    border-top:1px solid #000;
    width:30%;
  }
  .list_column_center{
    border-right:1px solid #000;
    border-top:1px solid #000;
    width:40%;
  }
  .list_column_header{
    border-top:1px solid #000;
    border-bottom:1px solid #000;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #title_area,#list_column_area,:deep(#calendar_column_area){
    display: flex;
    align-items: center;
  }
  #list_column_area div{
    height:40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  #calendar_button_area{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }
  .month_change{
    cursor: pointer;
    border-bottom: 1px solid #000;
  }
  
  :deep(.calendar_column){
    width:14%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_right){
    width:15%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_left){
    width:15%;
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom:1px solid #000;
  }
  
  
  :deep(.column_date){
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  :deep(.column_date_day){
    height:30px;
    display: flex;
    align-items: center;
  }
  :deep(.column_date_time){
    height:25px;
    width:100%;
    font-size: 13px;
    line-height: 15px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  :deep(.column_date_time_left){
    width: 55%;
    text-align: left;
    padding: 0;
    display: flex;
    justify-content: center;
  }


    @media screen and (min-width: 961px) {

        /* PC版 */
        .tabMenu li {
            padding: 10px 20px;
        }
        .tabContents{
            padding: 15px;
        }

        :deep(.column_date_blank){
            height: 100px;
        }
        :deep(.column_date){
            height: 100px;
        }
        .floating_over{
            display: none
        }
        
        .pc_only{
            display:revert
        }
        .sp_only{
            display:none
        }
    }
    @media screen and (max-width: 960px) {

        /* スマホ版 */
        .tabMenu li {
            padding: 5px;
            height:50px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .tabContents{
            padding: 5px;
        }


        /* スマホの場合は項目名を大きめにする */
        label{
            font-size: 19px;
        }
        :deep(.column_date_blank){
            height: 60px;
        }
        :deep(.column_date){
            height: 60px;
        }
        
        .floating_over{
            display: flex
        }
  
        .pc_only{
            display:none
        }
        .sp_only{
            display:revert
        }
    }
    

.balloon_parent:hover .balloon-top-right {
  display: inline;                /* インライン要素として表示 */
}
.balloon-top-right {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  right : -20px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 350px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top-right:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  left : 89%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}
</style>
